<template> 
    <div v-if="showComponent">
        <div class="modal fade show modal-disclaimer" style="display:block;" id="disclaimer-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-html="title"></h5>
                    </div>
                    <div class="modal-body" v-html="body"></div>
                    <button v-on:click="setDisclaimerShown" type="button" class="btn btn-primary btn-chevron-right modal-close" v-html="button"></button>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'ReusableDisclaimer',
        props: {
            params: {
                required: true
            }
        },
        computed: {
            title() {
                return this.params && this.params.title ? this.params.title : '';
            },
            body() {
                return this.params && this.params.body ? this.params.body : '';
            },
            button() {
                return this.params && this.params.button ? this.params.button : '';
            },
            showComponent(){
                let result = false;
                if (!this.isIpad && this.params !== null) {
                    result = this.getSessionStorageDisclaimer;
                }
                return result;
            },
            hasIndexRedirect(){
                return this.$store.getters.getIndexRedirect;
            },
            getSessionStorageDisclaimer(){
                var disclaimer = window.sessionStorage.getItem('reusableDisclaimerStates'),
                    showDisclaimer = true;
                if (disclaimer !== null) {
                    disclaimer = JSON.parse(disclaimer);
                    showDisclaimer = disclaimer[this.params.id];
                }
                return showDisclaimer;
            }
        },
        methods: {
            setDisclaimerShown() {
                this.$store.dispatch('setReusableDisclaimerStatus',{
                    id: this.params.id
                });
                this.$store.dispatch('storeReusableDisclaimerStatus');
                this.$emit('accepted');
            }
        }
    }

</script>